import { TRowComponentProps, TViewCommonOption } from '@libs/types';
import React, { MouseEventHandler } from 'react';
import { RowEnum } from '../../../types/enums';
import { RowRegularView } from './RowRegularView';
import { SelectorRegularView } from './SelectorRegularView';
import { SelectorExtraView } from './SelectorExtraView';

type TRowComponent = {
    handleClick: MouseEventHandler<HTMLButtonElement>;
    parentStyleNames?: TViewCommonOption['parentStyleNames'];
} & TRowComponentProps;

const ItemListComponent: React.FC<TRowComponent> = ({ handleClick, ...props }) => {
    const { value, isSelected, ...rest } = props;

    switch (props.id) {
        case RowEnum.ROW_REGULAR:
            return <RowRegularView handleClick={handleClick} {...rest} />;
        case RowEnum.SELECTOR_REGULAR:
            return <SelectorRegularView isSelected={isSelected} handleClick={handleClick} {...rest} />;
        case RowEnum.SELECTOR_EXTRA:
            return <SelectorExtraView isSelected={isSelected} handleClick={handleClick} {...rest} />;
        default:
            return <RowRegularView handleClick={handleClick} {...rest} />;
    }
};

export default ItemListComponent;
